import { render, staticRenderFns } from "./ShippedTab.vue?vue&type=template&id=adf23864&lang=pug&"
import script from "./ShippedTab.vue?vue&type=script&lang=js&"
export * from "./ShippedTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports